import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import RegionSubselect from '@/components/RegionSubselect'
import ViewPhotos from '@/components/ViewPhotos'
import Faq from '@/components/Faq/Faq'
import FaqDownloadingPhotos from '@/components/Faq/DownloadingPhotos'
import FaqDigipass from '@/components/Faq/Digipass'
import FaqSeasonDigipass from '@/components/Faq/SeasonDigipass'
import FaqAnnualDigipass from '@/components/Faq/AnnualDigipass'
import FaqImagic from '@/components/Faq/Imagic'
import TermsAndConditions from '@/components/TermsAndConditions/TermsAndConditions'
import TCDayDigipass from '@/components/TermsAndConditions/DayDigipass'
import TCSeasonDigipass from '@/components/TermsAndConditions/SeasonDigipass'
import TCAnnualDigipass from '@/components/TermsAndConditions/AnnualDigipass'
import TCImagic from '@/components/TermsAndConditions/Imagic'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import CookiePolicy from '@/components/CookiePolicy/'

import GuestServices from '@/components/GuestServices/GuestServices'
import GSRegionSelect from '@/components/GuestServices/GSRegionSelect'
import GSProductSelect from '@/components/GuestServices/GSProductSelect'
import GSSiteSelect from '@/components/GuestServices/GSSiteSelect'
import GSDynamicFAQ from '@/components/GuestServices/GSDynamicFAQ'
import SubmitSupportRequest from '@/components/GuestServices/SubmitSupportRequest/SubmitSupportRequest'

import VueI18n from 'vue-i18n'

Vue.use(Router)
Vue.use(VueI18n)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/region-subSelect',
      component: RegionSubselect
    },
    {
      path: '/:region(\\uk|us|mu|si|to)/:barcode',
      component: ViewPhotos
    },
    {
      path: '/view-photos/:region',
      component: ViewPhotos
    },
    {
      path: '/view-photos/:barcode/:region',
      component: ViewPhotos
    },
    {
      path: '/view-photos/',
      component: ViewPhotos
    },
    {
      path: '/terms-and-conditions',
      component: TermsAndConditions
    },
    {
      path: '/terms-and-conditions/day-digipass',
      component: TCDayDigipass
    },
    {
      path: '/terms-and-conditions/season-digipass',
      component: TCSeasonDigipass
    },
    {
      path: '/terms-and-conditions/imagic',
      component: TCImagic
    },
    {
      path: '/privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '/cookie-policy',
      component: CookiePolicy
    },
    {
      path: '/faq-and-support',
      component: Faq
    },
    {
      path: '/faq-and-support/downloading-photos',
      component: FaqDownloadingPhotos
    },
    {
      path: '/faq-and-support/digipass',
      component: FaqDigipass
    },
    {
      path: '/faq-and-support/annual-digipass',
      component: FaqAnnualDigipass
    },
    {
      path: '/faq-and-support/season-digipass',
      component: FaqSeasonDigipass
    },
    {
      path: '/faq-and-support/imagic',
      component: FaqImagic
    },
    {
      path: '/guest-services/',
      component: GuestServices,
      children: [
        {
          path: 'regionSelect',
          component: GSRegionSelect
        },
        {
          path: 'productSelect',
          component: GSProductSelect
        },
        {
          path: 'siteSelect',
          component: GSSiteSelect
        },
        {
          path: 'faq',
          component: GSDynamicFAQ
        },
        {
          path: 'supportRequest',
          component: SubmitSupportRequest
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }

    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  linkActiveClass: 'is-active'
})



// WEBPACK FOOTER //
// ./src/router/index.js